import Vue from 'vue'
import Vuex from 'vuex'

import EnviarArquivos from '@/components/EnviarArquivos/store'
import Login from '@/components/Login/store'
import TimeLine from '@/components/TimeLine/store'
import Usuarios from '@/components/usuarios/store'
import VisualizarArquivos from '@/components/VisualizarArquivos/store'
import ContaCliente from '@/components/ContaCliente/store'
import Report from '@/components/Report/store'
import Global from './Global'
import ContentManagement from '@/components/ContentManagement/store'

Vue.use(Vuex)

const modules = {
  EnviarArquivos,
  Login,
  TimeLine,
  Usuarios,
  VisualizarArquivos,
  ContaCliente,
  Report,
  Global,
  ContentManagement
}

export default new Vuex.Store({
  modules
})
